// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  position: relative;
  padding: 10px 25px;
  margin: 0;
  text-align: right;
  color: #2c3e50;
  background-color: #ecf0f5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.profile-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: contain;
  cursor: pointer;
}

.profile-image:hover {
  filter: brightness(0.9);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 1;
  background-color: #fff;
  border: 1px solid #ddd;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
  display: none;
  z-index: 10;
}

.dropdown-item {
  display: flex;
  padding: 15px;
  justify-content: end;
  align-items: center;
  gap: 5px;
  color: #2c3e50;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;
}

.dropdown-item i {
  font-size: 1.2rem;
  font-weight: 600;
}

.dropdown-item:hover {
  background-color: #f2f2f2;
  border-radius: 4px;
}

.dropdown-txt {
  background-color: #34495e;
  text-align: center;
  font-size: 1.1rem;
  padding: 25px 80px;
}

.dropdown-txt .text {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/profile.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".profile-container {\r\n  position: relative;\r\n  padding: 10px 25px;\r\n  margin: 0;\r\n  text-align: right;\r\n  color: #2c3e50;\r\n  background-color: #ecf0f5;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.profile-image {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  object-fit: contain;\r\n  cursor: pointer;\r\n}\r\n\r\n.profile-image:hover {\r\n  filter: brightness(0.9);\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 1;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  width: fit-content;\r\n  display: none;\r\n  z-index: 10;\r\n}\r\n\r\n.dropdown-item {\r\n  display: flex;\r\n  padding: 15px;\r\n  justify-content: end;\r\n  align-items: center;\r\n  gap: 5px;\r\n  color: #2c3e50;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.dropdown-item i {\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background-color: #f2f2f2;\r\n  border-radius: 4px;\r\n}\r\n\r\n.dropdown-txt {\r\n  background-color: #34495e;\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  padding: 25px 80px;\r\n}\r\n\r\n.dropdown-txt .text {\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
